import { render } from "./SubscriptionOrderView.vue?vue&type=template&id=a2d4cf96"
import script from "./SubscriptionOrderView.vue?vue&type=script&lang=js"
export * from "./SubscriptionOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__